import { render, staticRenderFns } from "./BaseIconSwitch.vue?vue&type=template&id=41367c58&scoped=true"
import script from "./BaseIconSwitch.vue?vue&type=script&lang=js"
export * from "./BaseIconSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41367c58",
  null
  
)

export default component.exports